import React from 'react';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
export const ElectricityIcon = (props) => {
    const { serviceID, value } = props;
    const classes = commonStyle();
    let colorSelected = classes.svg_selected;
    if (serviceID !== value) {
        colorSelected = classes.svg_non_selected;
    }

    return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style={{ enableBackground: 'new 0 0 512 512' }}
        >
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M255,61c-8.3,0-15,6.7-15,15s6.7,15,15,15c49.6,0,90,40.4,90,90c0,8.3,6.7,15,15,15s15-6.7,15-15
			C375,114.8,321.2,61,255,61z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={classes.svg_non_selected}
                        d="M217.3,4C149.6,18.2,94.6,72.6,80.2,140.8C68,198.4,83,256.2,121.5,299.4c18.8,21.1,29.6,49,29.6,76.6v30
			c0,20,13.1,36.9,31.1,42.8c5.9,35,36.3,63.2,73.9,63.2s68-28.2,73.9-63.2c18-5.9,31.1-22.8,31.1-42.8v-30
			c0-27.6,10.8-55.2,30.4-77.6C420.2,265.6,436,223.6,436,180C436,66.4,332.1-19.9,217.3,4z M256,482c-19.3,0-36.2-13.3-42.4-31.1
			h84.9C292.2,468.7,275.3,482,256,482z M331,406c0,8.3-6.7,15-15,15H196c-8.3,0-15-6.7-15-15v-15h150V406z M368.9,278.6
			c-20.9,23.9-33.8,52.6-37.1,82.3H180.2c-3.3-29.7-16.1-58.8-36.3-81.5c-32-36-44.6-84.3-34.3-132.4
			c11.9-56.2,57.7-101.9,114-113.6C319.5,13.3,406,85.4,406,180C406,216.3,392.8,251.3,368.9,278.6z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M45,180H15c-8.3,0-15,6.7-15,15s6.7,15,15,15h30c8.3,0,15-6.7,15-15S53.3,180,45,180z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M51.2,105L30,83.8c-5.9-5.9-15.4-5.9-21.2,0s-5.9,15.4,0,21.2L30,126.2c5.9,5.9,15.4,5.9,21.2,0
			C57.1,120.3,57.1,110.8,51.2,105z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M51.2,263.8c-5.9-5.9-15.4-5.9-21.2,0L8.8,285c-5.9,5.9-5.9,15.4,0,21.2c5.9,5.9,15.4,5.9,21.2,0L51.2,285
			C57.1,279.1,57.1,269.6,51.2,263.8z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M497,180h-30c-8.3,0-15,6.7-15,15s6.7,15,15,15h30c8.3,0,15-6.7,15-15S505.3,180,497,180z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M503.2,83.8c-5.9-5.9-15.4-5.9-21.2,0L460.8,105c-5.9,5.9-5.9,15.4,0,21.2c5.9,5.9,15.4,5.9,21.2,0l21.2-21.2
			C509.1,99.1,509.1,89.6,503.2,83.8z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M503.2,285L482,263.8c-5.9-5.9-15.4-5.9-21.2,0s-5.9,15.4,0,21.2l21.2,21.2c5.9,5.9,15.4,5.9,21.2,0
			S509.1,290.8,503.2,285z"
                    />
                </g>
            </g>
        </svg>
    );
};
